import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';

import ReCAPTCHA from 'react-google-recaptcha';
import { useMsal } from '@azure/msal-react';
import MD5 from "crypto-js/md5";
import { loginRequest } from '../components/microsoftLogin/msalConfig';

import '../styles/Login.css';
const siteKey = '6LdO3msrAAAAAEOUJb6wgbpbsfZKgPcjdA1mDwUW';
const API_BASE_URL = process.env.REACT_APP_BASE_URL;
const Login = () => {
     const baseUrl = process.env.REACT_APP_BASE_URL;
     const [userCode, setUserCode] = useState('');
     const [password, setPassword] = useState('');
     const [error, setError] = useState('');
     const [loading, setLoading] = useState(false);
     const navigate = useNavigate();
     const [responseMessage, setResponseMessage] = useState('');
     const [captchaValue, setCaptchaValue] = useState(null);
     const { instance } = useMsal();
     const handleCaptchaChange = (value) => setCaptchaValue(value);

     const handleSubmit = async e => {
          e.preventDefault();
          setError('');
          setLoading(true);
          try {
               const res = await fetch(
                    `${baseUrl}/newLogin`, {
                    method: 'POST',
                    headers: {
                         'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                         user_code: userCode,
                         password: password,
                    }),
               }
               );
               const data = await res.json();
               if (data.status) {
                    // Store token in sessionStorage instead of localStorage
                    sessionStorage.setItem('token', data.token);
                    sessionStorage.setItem('user_code', data.user_code);
                    sessionStorage.setItem('user_name', data.user_name);
                    sessionStorage.setItem('user_role', data.role);
                    sessionStorage.setItem('is_radiology_doctor', data.is_radiology_doctor);
                    sessionStorage.setItem('spl_admin', data.spl_admin);
                    sessionStorage.setItem('role', data.role);
                    localStorage.setItem('token', data.token);
                    localStorage.setItem('userRole', data.role);

                    const expiryTime = new Date().getTime() + 4 * 60 * 60 * 1000;
                    sessionStorage.setItem('expiry', expiryTime);

                    // Auto-logout after 4 hours
                    setTimeout(() => {
                         sessionStorage.removeItem('token');
                         sessionStorage.removeItem('user_code');
                         sessionStorage.removeItem('user_name');
                         sessionStorage.removeItem('expiry');
                         sessionStorage.removeItem('user_role');
                         sessionStorage.removeItem('spl_admin');
                         localStorage.removeItem('token');
                         localStorage.removeItem('userRole');

                         navigate('/login');
                    }, 4 * 60 * 60 * 1000);
                    if (data.password === 'default_password') {
                         navigate('/changepassword');
                    } else {
                         navigate('/dashboard');
                    }
                    // Redirect to dashboard
                    //  navigate('/dashboard');
               } else {
                    setError(data.message || 'Login failed');
               }
          } catch (err) {
               setError('Something went wrong. Please try again.');
          } finally {
               setLoading(false);
          }
     };

     return (
          <div className="login-page">
               <Container fluid className="h-100">
                    <Row className="h-100">
                         <Col md={7} className="login-illustration">
                              <div className="illustration-content">
                                   {/* <h2>Welcome to HRMS</h2> */}
                                   <img
                                        src="/login_internalhrms.jpg"
                                        alt="HR illustration"
                                        className="illust-image"
                                        style={{ width: "100%", borderRadius: "50px" }}
                                   />
                              </div>
                         </Col>
                         <Col md={5} className="login-form-side">
                              <div className="form-container">
                                   <h3 className="brand-title">HRMS</h3>
                                   <Form onSubmit={handleSubmit}>
                                        {error && <div className="text-danger mb-2">{error}</div>}
                                        <Form.Floating className="mb-3">
                                             <Form.Control
                                                  id="floatingUserCode"
                                                  type="text"
                                                  placeholder=" "
                                                  value={userCode}
                                                  onChange={e => setUserCode(e.target.value)}
                                                  autoComplete="off"
                                             />
                                             <label htmlFor="floatingUserCode">User Code</label>
                                        </Form.Floating>
                                        <Form.Floating className="mb-4">
                                             <Form.Control
                                                  id="floatingPassword"
                                                  type="password"
                                                  placeholder=" "
                                                  value={password}
                                                  onChange={e => setPassword(e.target.value)}
                                                  autoComplete="off"
                                             />
                                             <label htmlFor="floatingPassword">Password</label>
                                        </Form.Floating>
                                        {/* <div className="d-flex justify-content-center mb-3">
                                             <ReCAPTCHA sitekey={siteKey} onChange={handleCaptchaChange} />
                                        </div> */}
                                        <Button
                                             variant="dark"
                                             type="submit"
                                             className="w-100 mb-3"
                                             disabled={loading}
                                        >
                                             {loading ? 'Logging in...' : 'Login'}
                                        </Button>
                                        <div className="text-center">
                                             <a
                                                  href="https://central.vdcapp.in/forget-password"
                                                  className="forgot-link"
                                                  target="_blank"
                                                  rel="noopener noreferrer"
                                             >
                                                  Forgot password?
                                             </a>
                                        </div>
                                   </Form>

                                   {/* <button onClick={handleMicrosoftLogin} className="btn btn-primary w-100">
                                        Login with Microsoft
                                   </button> */}

                                   {responseMessage && (
                                        <div className="text-danger mt-3 text-center" style={{ fontSize: '14px' }}>
                                             {responseMessage}
                                        </div>
                                   )}
                              </div>
                         </Col>
                    </Row>
               </Container>
          </div>
     );
};

export default Login;
